import axios from './apiClient/axios'
import Vue from 'vue'
import store from '../stores/index'
const AUTH_URL = process.env.AUTH_URL

const auth = new Vue({
    beforeCreate() {
        axios.defaults.withCredentials = true
    },
    methods: {
        authenticateUser(code) {
            const url = AUTH_URL + 'authenticate'
            return axios.post(url, { code: code }).then(response => response.data)
        },
        validateAuthCode(code, id) {
            const url = AUTH_URL + 'validateauthcode'
            return axios.post(url, { code: code, id: id }).then(response => {
                return response.data
            })
        },
        isLoggedIn() {
            const url = AUTH_URL + 'isloggedin'
            return axios.get(url).then(response => response.data)
        },
        logout() {
            store.dispatch('toggleStaffMode')
            const url = AUTH_URL + 'logout'
            return axios.post(url).then(response => response.data)
        },
        checkSession() {
            const url = AUTH_URL + 'checksession'
            return axios.get(url).then(response => response.data)
        },
    },
})

export default {
    install: function(Vue) {
        Vue.prototype.$auth = auth
    },
}



// WEBPACK FOOTER //
// ./src/api/auth.js